import request from "@/utils/request";
import Axios from "axios";
import Qs from "qs";

/**
 * 登录
 * @param {} params
 */
export function getLogin(params) {
  return request({
    url: "login",
    method: "post",
    params
    // data: Qs.stringify(params)
  });
}

/**
 * 登出
 * @param {} params
 */
export function logOut(params) {
  return request({
    url: "/logout",
    method: "post",
    params
    // data: Qs.stringify(params)
  });
}
/**
 * POI地图
 */
export function getPoiMap() {
  return request({
    url: `/home/poiMap`,
    method: "post"
  });
}
/**
 * 获取节点企业数量
 */
export function getEntCount(params) {
  return request({
    url: `/home/getEntCount`,
    method: "post",
    data: Qs.stringify(params)
  });
}
/**
 *
 * @param {日期格式化} day
 */
export function getDay(day) {
  var today = new Date();
  var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
  today.setTime(targetday_milliseconds); //注意，这行是关键代码
  var tYear = today.getFullYear();
  var tMonth = today.getMonth();
  var tDate = today.getDate();
  tMonth = doHandleMonth(tMonth + 1);
  tDate = doHandleMonth(tDate);
  return tYear + "-" + tMonth + "-" + tDate;
}
/**
 *
 * @param {月份补零} month
 */
function doHandleMonth(month) {
  var m = month;
  if (month.toString().length == 1) {
    m = "0" + month;
  }
  return m;
}

/**
 * 消息推送列表
 * @param {} params
 */
export function getList(params) {
  return request({
    url: "/msg/getList",
    method: "post",
    data: params
  });
}
/**
 * 用户详情
 * @param {} params
 */
export function getEntInfo(params) {
  return request({
    url: "/getEntInfo.do",
    method: "post",
    data: params
  });
}
/**
 * 用户详情保存
 * @param {} params
 */
export function updateEntInfo(params) {
  return request({
    url: "/updateEntInfo.do",
    method: "post",
    // data: params
    data: Qs.stringify(params)
  });
}

export function getRead(params) {
  return request({
    url: "/msg/read",
    method: "post",
    data: params
  });
}
// 页面跳转获取token
export function getWanvToken() {
  let params = {
    userName: "lumicangData"
  };
  return Axios.post(
    "https://sipent.wanvdata.com/login/getWanvToken.do",
    Qs.stringify(params, { arrayFormat: "indices", allowDots: true })
  );
}
// 获取token跳转页面
export function aesEncryption(token) {
  let params = {
    userName: "lumicangData",
    token: token
  };
  return Axios.post(
    "https://sipent.wanvdata.com/login/aesEncryption_lumicang.do",
    Qs.stringify(params, { arrayFormat: "indices", allowDots: true })
  );
}
